import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { Table, UfinetBox, UfinetSectionBox, formatTableFilters, tableSortValueToSortDirection, } from 'ufinet-web-components'

import { UseQueryGetConfigGlobal } from 'request'
import { DataTablePageEvent } from 'primereact/datatable'
import { colsPercentageCommisionKamColData } from './PercentangeCommissionColData'




const PercentangeCommissionKamPage = () => {
  const intl = useIntl()
  const colsPercentageCommission = useMemo(() => colsPercentageCommisionKamColData(intl), [intl])





  const [paging, setPaging] = useState<any>()
  const [filterData, setFilterData] = useState<any>()



  const { data: percentageCommissionKam, isLoading: isLoadingPercentageCommissionKam } = UseQueryGetConfigGlobal(filterData)







  useEffect(() => {
    if (percentageCommissionKam) {
      const parsePagination = JSON.parse(percentageCommissionKam?.headers['x-pagination'])
      const formattedPagination = {
        totalElements: parsePagination.totalCount,
        totalPages: parsePagination.totalPages,
        pageSize: filterData && filterData.pageSize ? filterData.pageSize : parsePagination.pageSize,
        pageNumber: parsePagination.currentPage,
      }
      setPaging(formattedPagination)
    }
  }, [percentageCommissionKam])

  const onFilterClear = (): void => {
    setFilterData({})
  }

  const onFilter = (e: DataTablePageEvent): void => {
    const formattedFilters = formatTableFilters(e as any)
    setFilterData({
      ...filterData,
      ...formattedFilters
    })
  }

  const onPage = (e: DataTablePageEvent): void => {
    setFilterData({ ...filterData, pageNumber: e.page, pageSize: e.rows })
  }

  const onSort = (e: DataTablePageEvent): void => {
    const finalOrder = tableSortValueToSortDirection(e.sortOrder)
    setFilterData({
      ...filterData,
      sortField: e.sortField,
      sortOrder: finalOrder,
    })
  }



  return (
    <>
      <UfinetBox>

        <UfinetSectionBox>

          <Table
            // selectedValues={selectedValues}
            // onSelectionChange={permissions.canDelete ? onSelectionChange : undefined}
            // onRowEditComplete={permissions.canUpdate ? onRowEditComplete : undefined}
            content={percentageCommissionKam?.data}
            cols={colsPercentageCommission}
            // headerButtons={getHeadersButtons()}
            onFilterClear={onFilterClear}
            rowsPerPageOptions={[5, 10, 20, 50, 100, 250]}
            emptyMessage={isLoadingPercentageCommissionKam ? intl.formatMessage({ id: 'LOADING_DOTS' }) : undefined}
            lazySettings={
              paging && {
                ...paging,
                loading: isLoadingPercentageCommissionKam,
                onFilter,
                onPage,
                onSort,
              }
            }
          // emptyMessage={loadingRecords ? intl.formatMessage({ id: 'LOADING_DOTS' }) : undefined}
          />

        </UfinetSectionBox>
      </UfinetBox>
    </>
  )
}

export { PercentangeCommissionKamPage }


